// Renders a Sentinel Quote ID, linked to the quote in Sentinel when a deep-link
// URL is available. The server sends `sentinel_url` per quote (built from the
// quote-group GUID); when it's null — no GUID captured — we render plain text,
// never a broken link. stopPropagation so clicking the link inside a row doesn't
// also trigger the row's navigation.
export default function QuoteIdLink({ id, url, className = '' }) {
  if (id == null || id === '') return null;
  if (!url) return <>Q{id}</>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      title="Open quote in Sentinel"
      className={`underline decoration-dotted underline-offset-2 hover:text-tint ${className}`}
    >
      Q{id}
    </a>
  );
}
